

const TenderDescriptionID = ({ data }) => {
  return (
    <div className="md:space-y-2 space-y-0.5 md:p-0 p-1 lg:text-xs text-[8px]">
      {/* Item 1 */}
      <div className="flex  items-center">
      <label className="font-semibold text-gray-700 mr-2">1. Tender ID:</label>
        <span className="text-gray-600">{data.tenderID}</span>
      </div>

      {/* Item 2 */}
      <div className="flex items-center">
        <label className="font-semibold text-gray-700 mr-2">
        2. Org/Company Name:
        </label>
        <span className="text-gray-600">{data.invitation_for}</span>
      </div>

      {/* Item 3 */}
      <div className="flex items-center">
        <label className="font-semibold text-gray-700 mr-2">
        3. Tender Pattern:
        </label>
        <span className="text-gray-600">{data.type}</span>
      </div>
      {/* Item 4 */}
      {/* <div className="flex items-center">
        <label className="font-semibold text-gray-700 mr-2">
          4.Purchase Last Date: 
        </label>
        <span className="text-gray-600">{data.PurchaseLastDate}</span>
      </div> */}
      {/* Item 5 */}
      {/* <div className="flex items-center">
        <label className="font-semibold text-gray-700 mr-2">
          5.Prebid Meeting Date:
        </label>
        <span className="text-gray-600">{data.PrebidMeetingDate}</span>
      </div> */}
    </div>
  );
};

export default TenderDescriptionID;